export class DescriptionModel {
  Title?: string;
  Body?: string;
  Demands?: string;

  constructor(title?: string, body?: string, demands?: string) {
    this.Title = title;
    this.Body = body;
    this.Demands = demands;
  }
}
